import React from 'react';
import { SkyslopeAppsButton, SkyslopeAppsListItems } from '@skyslope/apps-menu';
import { useAuth } from '../../auth/use-auth-compat';
import { environmentConfig } from '../../lib/environment-config';

export function SkyslopeAppsMenu() {
  const { authState } = useAuth();
  const userToken = authState?.accessToken?.accessToken;

  if (!userToken) return null;
  return (
    <SkyslopeAppsButton
      env={environmentConfig.envName}
      currentAppName="digisign"
      userToken={userToken}
      classes={{ button: 'px-3 py-2 max-md:hidden', popover: 'z-[9999]' }}
    />
  );
}

export function SkyslopeAppsMenuItems() {
  const { authState } = useAuth();
  const userToken = authState?.accessToken?.accessToken;

  if (!userToken) return null;
  return <SkyslopeAppsListItems env={environmentConfig.envName} currentAppName="digisign" userToken={userToken} />;
}
